import { useParams } from 'react-router-dom';
import { MENTOR_API_URI } from '../../../api/index';
import './tutorial-document-frame.scss';

function TutorialDocument()
{  
    const { fileName } = useParams<{ fileName: string }>();
    const url = `${MENTOR_API_URI}/api/tutorialdocument/download?fileName=` + fileName + '#toolbar=0';

    return (
        <div id="document-wrapper" >
            <iframe id="tutorial-document" title={url} src={url}></iframe>
            <div className='overlay'></div>
        </div>

    )
}

export default TutorialDocument;